import { APIContactAddress, ContactAddress } from "../types/contact-addresses";

export const mapAPIContactAddressToContactAddress = (
  apiContactAddress: APIContactAddress
): ContactAddress => {
  return {
    country: apiContactAddress.country,
    state: apiContactAddress.state,
    city: apiContactAddress.city,
    postalCode: apiContactAddress.postal_code,
    street: apiContactAddress.street,
    neighborhood: apiContactAddress.neighborhood,
    municipality: apiContactAddress.municipality,
    exteriorNumber: apiContactAddress.exterior_number,
    interiorNumber: apiContactAddress.interior_number,
    isPrimary: apiContactAddress.is_primary,
    id: apiContactAddress.id,
    contactId: apiContactAddress.contact_id,
    createdAt: apiContactAddress.created_at,
    updatedAt: apiContactAddress.updated_at,
    isDeleted: apiContactAddress.is_deleted,
    deletedAt: apiContactAddress.deleted_at,
  };
};
